import { useEffect, useState } from 'react';
import axios from 'axios';
import { Languages } from '../../constants';
import { useApplicationParams, useLanguage } from '../../context';

const URL = `${process.env.REACT_APP_API_URL}/countries/list`;

export const useCountries = () => {
  const [data, setData] = useState({
    allCountries: [],
    availableCountries: [],
  });

  const { appVersion, platform, deviceId, userToken } = useApplicationParams();
  const { language } = useLanguage();

  useEffect(() => {
    const cancelToken = axios.CancelToken.source();

    axios
      .get(URL, {
        headers: {
          'Content-Type': 'application/json',
          'x-api-version': appVersion || '4.11.1',
          'x-api-key': process.env.REACT_APP_API_KEY,
          'x-api-os': platform || 'android',
          'x-user-lang': language || Languages.English,
          'x-api-device-id': deviceId || 'CBC64810-FF0C-4008-9558-A999C18085E7',
          authorization: userToken || '',
        },
        cancelToken: cancelToken.token,
      })
      .then((response) => {
        if (response.data.data && response.data.data.length > 0) {
          const allCountries = response.data.data;
          const uniqCountries = {};
          const availableCountries = allCountries
            .filter((c) => {
              if (c.flag && !!c.isShippingFeeActive) {
                if (uniqCountries[c.name]) {
                  return false;
                }

                uniqCountries[c.name] = true;
                return true;
              } else {
                return false;
              }
            })
            .sort((a, b) => {
              if (a.name > b.name) {
                return 1;
              } else if (a.name < b.name) {
                return -1;
              }

              return 0;
            });

          setData({
            allCountries,
            availableCountries,
          });
        }
      })
      .catch((error) => {
        console.error(`Error get countries: ${error?.message}`);
      });

    return () => {
      cancelToken.cancel();
    };
  }, [language]);

  return data;
};
